<template>
    <div class="create-account-component">      
     
        <div class="login-header">
            <!--<div class="title">DineSafeVT</div>-->
            <div class="dinesafe-label">Update Profile</div>
        </div>

        <div class="dx-field-label dinesafe-label">Password</div>
        <div class='create-account-input'>
            <DxButton 
                ref="btnChangePasswordRef" 
                type="normal"
                text="Change Password"
                styling-mode="contained" 
                :visible="true"
                width="100%"
                :disabled="false"
                @click="btnChangePasswordClick"
            />
        </div>

        <div class="dx-field-label dinesafe-label">Profile Info</div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtEmail"
                placeholder="E-mail"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.Email"
                :read-only="true"
            >       
                <DxValidator>
                    <DxRequiredRule message="E-mail is required" />
                </DxValidator>
            </DxTextBox>
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtFirstName"
                placeholder="First Name"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.FirstName"
            >       
                <DxValidator>
                    <DxRequiredRule message="First Name is required" />
                </DxValidator>
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtLastName"
                placeholder="Last Name"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.LastName"
            >       
                <DxValidator>
                    <DxRequiredRule message="Last Name is required" />
                </DxValidator>
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtPhoneNumber"
                placeholder="Phone Number"  
                mask= '+1 (000) 000-0000'
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.PhoneNumber"
            >       
                <DxValidator>
                    <DxRequiredRule message="Phone Number is required" />
                </DxValidator>
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtAddress1"
                placeholder="Address 1"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.Address"
            >       
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtAddress2"
                placeholder="Address 2"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.Address1"
            >       
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtCity"
                placeholder="City"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.City"
            >       
            </DxTextBox>       
        </div>

        <div class="create-account-input">
            <DxSelectBox
                :items="states"
                :value.sync="accountInfo.State"
                :show-clear-button="true"
                placeholder="State/Province"
            >       
            </DxSelectBox>
        </div>

        <div class='create-account-input'>            
            <DxTextBox
                name="txtPostalCode"
                placeholder="Postal Code"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo.ZipCode"
            >       
            </DxTextBox>       
        </div>

        <DxCheckBox
            text="Allow restaurants to see my information (optional)"
            :value.sync="accountInfo.ShareMyInfo"
        />

        <div class="terms-and-conditions-container">
            <DxCheckBox
                text="I agree to the "
            >
                <DxValidator>
                    <DxRequiredRule 
                        message="You must accept the Terms and Conditions"  
                    />
                </DxValidator>
            </DxCheckBox>              
            <DxButton
            ref="btnTermsRef"
            text="Terms and Conditions"
            styling-mode="text"
                @click="btnTermsClick($event)"
            :element-attr="{
                id: 'btnTermsAndConditions',
                class: 'btn-terms-and-conditions',  //I set a class here so I can style the button like a hyperlink
                }"
            />
        </div>

        <div class='center-button'>
            <DxButton 
                ref="btnCreateAccountOkRef" 
                type="success"
                text="Save Profile"
                styling-mode="contained" 
                :visible="true"
                width="100%"
                :disabled="false"
                @click="btnEditAccountOkClick"
            />
        </div>
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import DxTextBox from "devextreme-vue/text-box";
    import service from '../../src/data/contact-info-data';
    import DxSelectBox from 'devextreme-vue/select-box';
    import DxValidator, { DxRequiredRule, DxCustomRule } from "devextreme-vue/validator";
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    import DxValidationGroup from "devextreme-vue/validation-group";
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import notify from 'devextreme/ui/notify';

    export default {
        components: {
            DxButton,
            DxTextBox,
            DxSelectBox,
            DxValidator, DxRequiredRule, DxCustomRule,
            DxValidationGroup,
            DxValidationSummary,
            DxCheckBox,
            notify,
        },
        data() {
            const states = service.getStates();

            return {
                states: states,
                accountInfo:
                    {
                        Email: null,
                        FirstName: null,
                        LastName: null,
                        PhoneNumber: null,
                        Address: null,
                        Address1: '',
                        City: null,
                        State: "VT",
                        ZipCode: null,
                    }
                
            }
        },
        created(){
            //Get the User Information
            this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetUserData',
                {       
                    UserId: JSON.parse(localStorage.dinesafeUser).UserId,
                }
                ).then(function(data){         
                    if(data.body != null && data.body != ''){
                        var responseData = JSON.parse(data.body);      

                        this.accountInfo = responseData[0];                  
                    }
                });
        },
        mounted(){

        },
        methods:{
            btnEditAccountOkClick(e){
                //console.log("btnEditAccountOkClick");
                
                //Validate the user inputs.
                if (!e.validationGroup.validate().isValid) {
                    return;
                }

                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'EditUser',
                {       
                    UserId: JSON.parse(localStorage.dinesafeUser).UserId,
                    FirstName: this.accountInfo.FirstName,
                    LastName: this.accountInfo.LastName,
                    PhoneNumber: this.accountInfo.PhoneNumber,          
                    Address: this.accountInfo.Address,
                    Address1: this.accountInfo.Address1 == null ? '' : this.accountInfo.Address1,
                    City: this.accountInfo.City,
                    StateProvince: this.accountInfo.State,
                    PostalCode: this.accountInfo.ZipCode,
                    ShareMyInfo: this.accountInfo.ShareMyInfo,
                }
                ).then(function(data){         
                    if(data.body != null && data.body != ''){
                        var responseData = JSON.parse(data.body);      

                        //console.log("User created, UserId: " + responseData[0].UserId);

                        var message = responseData[0].Message;

                        if(message == 'Success!'){
                            //Store the UserId, log the user in
                            this.$store.commit("setUserId", responseData[0].UserId);

                            notify(
                            {
                                message: "Profile saved", 
                                type:"success", 
                                width:100, 
                                displayTime: 2000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });

                            this.$router.push("/home");
                        }
                        else{
                            notify(
                            {
                                message: "There was an issue saving", 
                                type:"warning", 
                                width:100, 
                                displayTime: 3000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });
                        }
                    }
                });
            },
            btnChangePasswordClick(e){
                this.$router.push("/changepass");
            }           
        }
    }
</script>

<style scoped>
    .dinesafe-label{
        padding-bottom:10px;
    }
    .center-button{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
    }

    .x-center-button > .dx-button-mode-outlined{
        color: #147c33;
        border-color: #147c33;
    }

    .continue-to-payment{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
    }

    .dx-field-label{
        width: 100%;
        padding-top: 20px;
    }

    .create-account-input {
        /* display: block */
        padding-bottom: 10px;
        padding-top:10px;

        margin:auto;
        max-width: 400px;
    }

</style>

<style scoped>
    /* Hide the validation message that would show right below an editor with invalid data */
    .dx-invalid-message > .dx-overlay-content{
        visibility: hidden;
    }
</style>
